module.exports = __webpack_public_path__ + "img/product1.ab0c52f4.png";